import { render } from "./Header.vue?vue&type=template&id=1ba0d900&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=1ba0d900&scoped=true&lang=css"
import "./Header.vue?vue&type=style&index=1&id=1ba0d900&lang=css"
script.render = render
script.__scopeId = "data-v-1ba0d900"

export default script